module.exports = __webpack_public_path__ + "img/karagandy6.56de95cc.jpg";